module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-right-white-54520c818fb5180feff871fd4c09d6c8.svg";